import { render, staticRenderFns } from "./XiuxianActivity.vue?vue&type=template&id=67258db4&scoped=true&"
import script from "./XiuxianActivity.vue?vue&type=script&lang=js&"
export * from "./XiuxianActivity.vue?vue&type=script&lang=js&"
import style0 from "./XiuxianActivity.vue?vue&type=style&index=0&id=67258db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67258db4",
  null
  
)

export default component.exports